"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YesNoFieldView = void 0;
const input_state_1 = require("../../../components/input/input.state");
const switch_input_1 = require("../../../components/input/switch.input");
const i18n_1 = require("../../../i18n");
exports.YesNoFieldView = {
    viewInline(field) {
        return (0, i18n_1.Translate)(field.value ? i18n_1.T.YES : i18n_1.T.NO);
    },
    viewDetail(field) {
        return null;
    },
    viewEdit(field, ctrl) {
        let inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new input_state_1.InputState(field.schema.displayName);
            inputState.onValue(() => field.Mutator.manual(inputState.value));
            inputState.setValue(field.value);
            ctrl.changeState.addState(field.id, inputState);
        }
        return switch_input_1.SwitchInput.view(inputState);
    },
    hasClear(field) {
        return false;
    },
};
//# sourceMappingURL=yesno.field.view.js.map